import { useState } from 'react';
import TopNav from '@/pages/home/components/TopNav';
import HeroSection from '@/pages/home/components/HeroSection';
import ClueBoard from '@/pages/home/components/ClueBoard';
import EvidenceGrid from '@/pages/home/components/EvidenceGrid';
import StatsPanel from '@/pages/home/components/StatsPanel';
import RelationGraph from '@/pages/home/components/RelationGraph';
import TimelineSection from '@/pages/home/components/TimelineSection';
import DiscussionSection from '@/pages/home/components/DiscussionSection';
import MethodSection from '@/pages/home/components/MethodSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    const target = document.getElementById('clues');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopNav />
      <main className="flex-1">
        <HeroSection query={query} onQueryChange={setQuery} onSearch={handleSearch} />
        <ClueBoard query={query} onQueryChange={setQuery} />
        <EvidenceGrid />
        <StatsPanel />
        <RelationGraph />
        <TimelineSection />
        <DiscussionSection />
        <MethodSection />
      </main>
      <SiteFooter />
    </div>
  );
}